import { ButtonHTMLAttributes, useState, useRef } from 'react';
import { Button } from './Button';
import { Icon } from './Icon';

interface IDropdownItem {
	text: string;
	onClick: () => void;
}
interface IDropdownButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	items: IDropdownItem[];
	text: string;
	modifier?: string;
}
export const DropdownButton = (props: IDropdownButtonProps) => {
	const { items, text, ...rest } = props;

	const [showDropList, setShowDropList] = useState(false);
	const [dropListStyle, setDropListStyle] = useState<React.CSSProperties>({});
	const toggleRef = useRef<HTMLDivElement>(null);

	const toggleDropdownList = () => {
		setShowDropList((prev) => {
			if (!prev && toggleRef.current) {
				const rect = toggleRef.current.getBoundingClientRect();
				setDropListStyle({
					top: `${rect.top + rect.height}px`,
					left: `${rect.left}px`,
					width: `${rect.width}px`,
				});
			}
			return !prev;
		});
	};

	const itemClick = (item: IDropdownItem) => {
		item.onClick();
		setShowDropList(false);
	};

	const classes = rest.className ? `button is-dropdown ${rest.className}` : `button is-dropdown `;

	if (items.length === 1) {
		return (
			<Button className={`button ${rest.className}`} onClick={() => itemClick(items[0])}>
				<span className="drop-text">{text}</span>
			</Button>
		);
	}

	return (
		<>
			<div className={`dropdown-container ${props.modifier || ''}`}>
				<div className="toggle-container" ref={toggleRef}>
					<Button className={classes} onClick={toggleDropdownList}>
						<span className="drop-text">{text}</span>
						{showDropList ? <Icon iconClass="caret-up" /> : <Icon iconClass="caret-down" />}
					</Button>
				</div>
				{showDropList && (
					<>
						<div className="dropdown-background" onClick={toggleDropdownList}></div>
						<div className="dropdown-list" style={dropListStyle}>
							{items.map((item, index) => (
								<div className="dropdown-item" key={`${item.text}-${index}`}>
									<Button className="button is-small is-inverted is-dropdown-item" onClick={() => itemClick(item)}>
										{item.text}
									</Button>
								</div>
							))}
						</div>
					</>
				)}
			</div>
		</>
	);
};
